<template>
  <!--劳动合同-->
  <div class="labor-tpl">
    <form>
      <h1>产品经销合同</h1>
      <p class="l3">
        甲方：<input class="default" name="aName" type="text" v-model="form.aName">
      </p>
      <p class="l3">
        乙方：<input class="default" name="bName" type="text" v-model="form.bName">
      </p>
      　
      <p>
        鉴于双方在平等自愿的基础上就甲方委托乙方作为上述产品的
        <input type="text" name="productAdd" v-model="form.productAdd" class="default2">地区经销商事宜，特订立协议如下：
      </p>
      <p>
        第一条：定义
      </p>
      <p>
        一、产品本协议中所称“产品”，是指<input type="text" name="productType" v-model="form.productType" class="default33">系列产品。
      </p>
      <p>
        二、地区本协议中所称“地区”，是指<input type="text" name="productAg" v-model="form.productAg" class="default4">经双方经书面同意的其他地区。
      </p>
      <p>
        三、商标和专名本协议中所称“商标”和“专名”，是分别指
        <input name="productAllName" type="text" v-model="form.productAllName" class="default2">（商标的全称和专名的全称）。指定产品的中文名称：<input
        type="text" v-model="form.productName" name="productName" class="default33">。（暂定名，乙方将可能在此产品的整体CI策划中，给予其名称全新策划）
      </p>
      <p>
        第二条：经销权甲方兹给予乙方以“商标”和“专名”向“地区”内客户总经销“产品”的权利。
      </p>
      <p>
        第三条：专管权一、交易甲方不得再将“产品”售予、让予或以其他方式使“地区”内乙方以外的任何个人、公司或其他主体取得“产品”。
      </p>
      <p>
        二、委托甲方不得委托“地区”内乙方以外的其他个人、公司或其他主体作为其经销商，以进口和销售“产品”。
      </p>
      <p>
        三、询购甲方收到“地区”内任何客户有关“产品”的询购，均应交给乙方。
      </p>
      <p>
        四、再进口甲方应采取适当措施防止他人在“地区”内出售“产品”，并不得将“产品”卖给甲方知道的或有理由相信拟在“地区”内再进口或出售“产品”的第三者。
      </p>
      <p>第四条：价格、条件一、价格</p>
      <p>
        1、 甲方给予乙方的价格和条件，应随时由甲方和乙方商定，此项价格和条件的确定并应考虑到正常贸易惯例及经常存在的市场竞争情况，使双方从销售中获得相当利润。
      </p>
      <p>2、 甲方给予乙方一个较稳定的市场价格，如有变动，也是每年年初发给的年度价格表。
      </p>
      <p>3、 如有产品价格变动，甲方应在改变价格和折扣的30天前书面通知乙方，所有改变价格期限之前双方签定的合同一律保证价格，并按正常交货期交货。
      </p>
      <p>4、 乙方所享受的代理折扣由双方另行商定，但甲方应当保证乙方应获得不低于
        <input name="discount" type="text" v-model="form.discount" class="default2">的折扣。
      </p>
      <p>二、单独合同在每次具体购买产品时，双方应缔结单独合同。
      </p>
      <p>
        三、最惠条款甲方声明，本协议中各项条款是甲方现在给予经销商和制造商最优惠的条款，
        今后如甲方向任何其他经销商或制造商销售“产品”时提供比本协议更有利于买方的条件时，甲方应立即以书面通知乙方，并向乙方提供此项更有利的条件。
      </p>
      <p>第五条：甲方的责任甲方同意在下列方面承担义务：
      </p>
      <p>1、 承诺并保证作为 产品的中国总代理完全有资格与乙方签订本协议。
      </p>
      <p>2、 自费提供样品和一切可以供应的广告资料。
      </p>
      <p>3、 提供现行的国内价目表，并将价目表内任何预期的变更迅速通知乙方。
      </p>
      <p>4、 甲方将向乙方免费提供一定数量的产品资料。大批量的资料在必要的情况下可由乙方申请甲方提供。
      </p>
      <p>5、 应及时向乙方提供其产品在国际市场上最新的行业动态信息，经常提供有利于推销产品的意见，以便乙方能采取多元化的市场推广策略和销售方式。
      </p>
      <p>6、 甲方将对乙方的工程师提供全面的技术培训，并提供足够的技术支持。
      </p>
      <p>7、 甲方对于乙方售出的产品，凡是属于产品质量问题的而引起的损失，一切均由甲方承担责任或给予免费更换。
      </p>
      <p>第六条：乙方的责任
      </p>
      <p>1、 为在“地区”内推销“产品”并为客户服务，应自费提供和保持一个有经营能力的机构，
        并尽一切努力争取达到有利于甲方为利用“地区”内各种销售机会而制定的销售指标。
      </p>
      <p>2、 乙方应根据需要，在“地区”内发展区域性代理商和分销商，签订合同和管理将由乙方独立负责。
      </p>
      <p>3、 乙方将配备足够的销售工程师和技术工程师来配合市场销售的需求，他们会全面了解系列产品的特性及用途，并能够承担培训，现场检测服务和操作示范等任务。
      </p>
      <p>4、 供给甲方有关销售“产品”的详细报告，以及尽可能多的有关“地区”内各种销售机会和竞争者推销活动的情报。
      </p>
      <p>5、 乙方应尊重和保护甲方的知识产权，并保证不将售出的任何甲方产品`复制后用于商业目的。
      </p>
      <p>
        第七条：双方关系根据本协议所建立的甲方和乙方，在协议有效期内的关系仅属卖方和买方的关系。任何一方均无权对某一第三者代表另一方，
        或以另一方的名义签订合同。本协议并不产生代理权，如果任何一方以另一方的名义或以另一方代理人的名义行事，以致另一方遭受损失时，
        该导致损失的一方，应使受害的一方不负担由此而发生的费用。双方并未也无意建立任何代理、合伙、合营企业或雇主和雇员的关系。
      </p>
      <p>
        第八条：甲方名称等的使用
      </p>
      <p>一、特许乙方得为商业上的目的使用“商标”和“行名”或它们的简称或变称，并得标明自己为“地区”内“产品”的经销商。
      </p>
      <p>二、注册如乙方提出要求，甲方应自费负责为“商标”和“专名”在“地区”内办理申请、正式注册并保持其效力。
      </p>
      <p>第九条：期限、终止本协议自<input :value="new Date() | format('YYYY年MM月DD日')" type="text" class="default2"/>起生效，
        有效期为<input name="yearNum" type="text" v-model="form.yearNum" class="default15">年，如遇下列情况和条件，本协议应终止：
      </p>
      <p>
        １，如任何一方有违背本协议的实质行为，另一方得以书面通知该方，叙述此种违约行为，
        并说明除非该方对此种违约行为按本节规定加以纠正，否则另一方将按照本节规定终止本协议。如该通知发出后九十天内仍未得到纠正，则本协议根据这一事实在上述九十天期终时即时终止。
      </p>
      <p>
        ２，如任何一方根据破产法或债务人救济法提出或同意提出破产申请或其他救济申请，
        或被裁定破产，或解散，或清理，或对债权人作任何转让，或对该方指定了产业管理人或类似人员，则在上述任何情况下，另一方得在任何时侯以书面通知即终止本协议。
      </p>
      <p>３，如遇本协议所规定的某种不可抗力事由，以致协议一方在超过
        <input name="dayNum" type="text" v-model="form.dayNum" class="default15">天期限后尚无法履行其义务时，则另一方可在任何时候以书面通知立即终止本协议。
      </p>
      <p>第十条：解约的影响凡在本协议终止前双方间已发生而尚未了结的任何债务，或在本协议终止前由于一方违约而发生的另一方的损害赔偿请求权，均不受本协议终止的影响。
      </p>
      <p>第十一条：保证</p>
      <p>一、标准甲方向乙方保证，所有“产品”均符合“地区”内的标准。可以出售，并适合销售目的。甲方并保证“产品”在原料和制造工艺方面均符合质量标准。
      </p>
      <p>二、免受损失凡因“产品”被指称质量低劣，或因侵犯专利、商标，或因在“地区”内销售或使用“产品”而引起的其他任何类似的责任事由，甲方应保护乙方，使之不受损失。
      </p>
      <p>三、质量如乙方发现任何“产品”质量低劣，并将此事实通知甲方，甲方应按乙方提出的要求，立即予以调换或对乙方给予补偿，
        其费用由甲方自行负担。对由于上述调换或补偿而引起的损害，乙方不丧失其索赔权。
      </p>
      <p>第十二条：一般条款</p>
      <p>
        一、不可抗力本协议任何一方如遇到非所能控制的事由，以致直接或间接地造成任何延误或无法履行本协议及（或）各个单独合同的一部或全部条款时，
        则在此范围内得以免除其责任。此类事由包括但不限于：水灾、火灾、海啸、地震、以外事故或机械故障、天灾、战争、封锁、禁运、劫持、战争威胁、
        战争性情况、扣押、暴动、动员、暴乱、非暴力骚乱、革命、制裁、抢劫、罢工、劳动纠纷、工业干扰、动力供应不足、缺乏正常运输工具
        、金融恐慌、交易所关闭、国有化、禁止进口或出口、拒发政府命令、敌对行动或其他类似或不类似上述原因而非该方或双方所能控制的。
        如由于立法或政府行政命令以致任何一方或双方失去根据本协议应得的利益时，
        双方应重新审查本协议的条款以便恢复任何一方或双方根据本协议原已取得的同样的相应的地位。
      </p>
      <p>由于发生不可抗力事由的书面的通知，应由受影响一方以合理速度送达另一方。
      </p>
      <p>二、转让本协议任何一方在未征得另一方书面同意之前，不得转让本协议或本协议内规定的任何权利和义务。任何转让在未征得对方事前明确的书面同意之前，应属无效。
      </p>
      <p>三、商业机密本协议任何一方均不得在本协议期限内或期满后<input name="endDayNum" type="text" v-model="form.endDayNum" class="default15">内，对不论与另一方有否竞争的任何个人、行号或公司泄漏有关另一方业务经营或行情的任何消息或情报。
      </p>
      <p>
        四、通知根据本协议规定所发出的任何通知应以中文和英文做成书面，并以预付邮资的航空挂号信，按上文载明的地址或本协议任何一方可能按本节规定通知送达的其他地址，
        送交收件人。任何此种通知应视为在付邮日后第<input name="recDay" type="text" v-model="form.recDay" class="default15">
        个营业日送达。而此种通知正式付邮的证件，应视为送达此种通知的充分证明。
      </p>
      <p>五、适用法律和贸易条款本协议的成立、效力、解释和履行，应以<input name="country" type="text" v-model="form.country" class="default1">国法律为准。
        本协议内的贸易条件应服从最新修订的<input name="countryTips" type="text" v-model="form.countryTips" class="default1">条款的规定和解释。
      </p>
      <p>六、仲裁所有其他一切来自本协议或关于本协议、或关于违背本协议的争执或异议，在双方通过善意协商未能达成和解时，
        应提交苏州仲裁委员会按其仲裁规则进行仲裁，裁决应视为终局裁决，对协议双方均有约束力。
      </p>
      <p>七、可分割性本协议内各条款应视为可以分割，本协议内任何条款的无效，不应影响本协议其余条款的效力。</p>
      <p>八、保留权利协议任何一方在任何时候不坚持另一方执行本协议的任何条款时，不应视为放弃此项条款或放弃以后坚持另一方执行此项条款的权利。</p>
      <p>
        九、其他约定本协议包括双方关于本协议主题的全部协议和谅解，并取代双方以前关于本协议主题以书面或口头提出的任何性质的讨论所达成的一切协议和谅解，
        除本协议有明文规定者外，其他有关本协议主题的任何条件、定义、保证或声明，对双方均无约束力。
      </p>
      <p>关于本协议的任何更正、修改、更换或变更，以书面为之，并明确与本协议有关、由协议双方正式授权的人员或代表签署。</p>
      <p>为证明起见，本协议做成一式两份，在本协议起自所载的日期内双方正式授权的人员或代表签署。</p>
      <div class="list">
        <p>
          甲方（盖章）：<br/>
          <input type="text" name="aName" v-model="form.cName" class="default"/>
        </p>
        <p>
          乙方（签字）：<br/>
          <input type="text" name="bName" v-model="form.dName" class="default"/>
        </p>
      </div>
      <input type="hidden" value="product" name="tempType"/>
    </form>
  </div>
</template>

<script>
export default {
  name: "labor",
  data() {
    return {
      form: {
        aName: '',
        bName: '',
        cName: '',
        dName: '',
        productAdd: '',
        productType: '',
        productAg: '',
        productName: '',
        productAllName: '',
        discount: '',
        yearNum: '',
        dayNum: '',
        endDayNum: '',
        recDay: '',
        country: '',
        countryTips: '',
      }
    }
  },
  methods: {
    submit: function () {
      // 子组件中触发父组件方法ee并传值cc12345
      //this.$emit('eeb', this.form)
    },
  }
}
</script>

<style lang="less" scoped>
input {
  width: 100px;
  height: 24px;
  line-height: 24px;
  outline: none;
  border: none;
  border-bottom: 1px solid #000;
  padding: 0 6px;
  resize: none;
  overflow: hidden;
  vertical-align: middle;
}

h1 {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 80px;
}

.labor-tpl {
  width: 100%;
  padding-top: 100px;
  padding-bottom: 60px;
  height: auto;
  font-size: 16px;
  font-family: '宋体';

  p.l3 {
    margin: 32px;
    text-indent: 0px;
  }

  .list {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      text-indent: 0px;
    }
  }

  .default {
    width: 50%;
  }

  .default15 {
    width: 15%;
  }

  .default2 {
    width: 20%;
  }

  .default3 {
    width: 30%;
  }

  .default33 {
    width: 33%;
  }

  .default4 {
    width: 40%;
  }

  p {
    text-indent: 32px;
    line-height: 2;
  }
}
</style>



// WEBPACK FOOTER //
// components/sys-contract/product.vue